/* eslint-disable jsx-a11y/img-redundant-alt */
import { Switch } from "@mantine/core";
import React, { useState } from "react";
import htmlParser from 'react-html-parser';
import { FaTrash } from "react-icons/fa";
import { FiEdit } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { portfolioDelete } from "../../redux/actions/frontendActions/portfolioActions";
const DashboardItemCard2 = ({blog , index}) => {

  const [switchActive , setSwicthActive] =useState(false);

  const handleSwitch =(e) => {
   setSwicthActive(!switchActive)
  }
const dispatch =useDispatch();

  return (
    <>
    <div className="dashboard-card-container" key={index}>
      <div className="card-wrapper">
        <div className="image-area">
          <img src={blog.image} alt="image" />
        </div>
        <div className="text-container">
          <h4>{blog.title}</h4>
         <p>{htmlParser(blog?.description.slice(0 , 100))} </p>
          <h6>{blog.categories}</h6>

          <div className="action-flex">
            <div className="edit">
              <FiEdit />
            </div>
            <div className="delete">
              <FaTrash onClick={()=>dispatch(portfolioDelete(blog._id))} />
            </div>
          </div>
        </div>
        <div className="swicth">
      <Switch name="switch" onChange={handleSwitch} label={switchActive? "Approved" : "Disapprove"} />
    </div>
      </div>
   
    </div>
    
   </>
  );
};

export default DashboardItemCard2;
